import React, { useContext } from 'react';
import GitHubIcon from '@material-ui/icons/GitHub';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import FacebookIcon from '@material-ui/icons/Facebook';

import { ThemeContext } from '../../contexts/theme';
import { rgB, rgW } from '../../assets/projects/index';
import { about, contact } from '../../portfolio';
import './Contact.css';

/* ------------------------- component ------------------------- */
const Contact = () => {
  const [{ themeName }] = useContext(ThemeContext);

  const { social } = about;
  if (!contact.email) return null;

  /* ------------------------- render ------------------------- */
  return (
    <section className='section contact center' id='contact'>
      <h2 className='section-title section-title-btm'>Contact</h2>
      <div className='center'>
        <a
          className='email'
          href={`mailto:${contact.email}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span type='button' className='btn btn-round'>
            Email
          </span>
        </a>

        {social && (
          <>
            {social.github && (
              <a
                href={social.github}
                target="_blank"
                rel="noopener noreferrer"
                aria-label='github'
                className='link link-icon'
              >
                <GitHubIcon />
              </a>
            )}

            {social.linkedin && (
              <a
                href={social.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                aria-label='linkedin'
                className='link link-icon'
              >
                <LinkedInIcon />
              </a>
            )}

            {social.facebook && (
              <a
                href={social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                aria-label='facebook'
                className='link link-icon'
              >
                <FacebookIcon />
              </a>
            )}
            {social.researchgate && (
              <a
                href={social.researchgate}
                target="_blank"
                rel="noopener noreferrer"
                aria-label='researchgate'
                className='link link-icon'
              >
                <img name='en' alt='researchgate icon' src={themeName === 'dark' ? (rgW) : (rgB)} className='flag-icon' />
              </a>
            )}
          </>
        )}
      </div>

    </section>
  );
};

export default Contact;
